/**
 * Toast — 操作反馈（自动消失）
 */

import { useEffect, useState, ReactNode } from 'react';

export type ToastVariant = 'success' | 'error' | 'info';

export interface ToastProps {
  variant?: ToastVariant;
  duration?: number;
  onClose?: () => void;
  children: ReactNode;
}

const variantClasses: Record<ToastVariant, string> = {
  success: 'bg-oasis text-white',
  error: 'bg-error text-white',
  info: 'bg-info text-white',
};

export function Toast({
  variant = 'info',
  duration = 3000,
  onClose,
  children,
}: ToastProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-50">
      <div
        className={`rounded-md px-4 py-2.5 text-sm font-medium shadow-lg ${variantClasses[variant]}`}
      >
        {children}
      </div>
    </div>
  );
}
